import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { throwError } from 'rxjs';
import { environment } from '../environments/environment';
import { AppModule } from './app/app.module';

// Angular CLI controls dev/prod mode via build config (no enableProdMode() here)
// Runtime config is loaded via APP_INITIALIZER in AppModule

// All runtime configuration should flow through your existing APP_INITIALIZER
// chain (you already added RuntimeConfigService.loadConfig() there), not via
// XMLHttpRequest in main.ts!

// platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .catch(err => console.error(err));

// TODO ↓ All this needs to go away once the Object.assign(environment, parsed) is removed
export const main = () =>
  new Promise((resolve) => {
    // let appConfig: any;
    const url = `/assets/data/config.json`;
    // Need for cache busting
    const datetime = new Date().toISOString();
    const cbURL = `${url}?cb=${datetime}`;
    const request: XMLHttpRequest = new XMLHttpRequest();
    const reqState200 = 200;
    const reqState304 = 304;

    request.open('GET', cbURL, false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request.onerror = (error: any) => {
      // eslint-disable-next-line no-restricted-properties
      console.error('Error reading configuration file');
      resolve(error);
      return throwError(error.json().error || 'Server error');
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onSuccess = (responseData: any) => {
      const parsed = JSON.parse(responseData);
      Object.assign(environment, parsed);
      return (
        platformBrowserDynamic()
          .bootstrapModule(AppModule)
          // eslint-disable-next-line no-restricted-properties
          .catch((e) => console.error(e))
      );
    };
    request.onreadystatechange = () => {
      if (request.status === reqState200 || request.status === reqState304) {
        onSuccess(request.response);
      }
    };

    // if (request.OPENED)
    request.send(null);
  });

// Since this is main.ts (browser-only), we don't need platform detection
// Just bootstrap the app directly
if (document.readyState === 'complete') {
  main();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    main();
  });
}
